<template>
    <div>
        <!-- Top card section, clickable -->
        <div
            @click="toggleIsExpanded()"
            class="px-4 pt-4 cursor-pointer z-0 bg-white rounded-t-xl border border-b-0 border-stone-200 shadow-xs"
        >
            <div class="mb-2 flex items-center gap-1">
                <slot name="badges" />
            </div>

            <slot
                name="visibleDetails"
                :isExpanded="isExpanded"
            />
        </div>

        <!-- Middle card section, not clickable -->
        <div
            class="px-4 z-0 bg-white border border-stone-200 border-t-0 border-b-0"
        >
            <slot
                name="hiddenDetails"
                :isExpanded="isExpanded"
            />
        </div>

        <!-- Bottom card section, not clickable -->
        <div
            class="px-4 pb-4 z-0 bg-white rounded-b-xl border border-stone-200 border-t-0 shadow-xs"
        >
            <!-- Content -->
        </div>
    </div>
</template>

<script setup lang="ts">
    import { ref } from 'vue'

    const isExpanded = ref<boolean>(false)

    const toggleIsExpanded = () => {
        isExpanded.value = !isExpanded.value
    }

    defineExpose({
        isExpanded,
    })
</script>
